import * as yup from 'yup'

const validationSchema = yup.object().shape({
  name: yup.string().required().min(1),
  description: yup.string(),
})

export default validationSchema
